import sample_1 from './100_74323.jpg';

export const basicsComfortFitImpressions = {
    sample_1,
};
